import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { TableActionType as ta } from '@/util/enum';
import { DefaultListFeilds as df, ExportStatus } from '../../types';
import { tooltipStyle, tooltip, cellWidth } from '@/components/TableCell';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '生成序号',
            dataIndex: df.id,
            key: df.id,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '报表名称',
            dataIndex: df.name,
            key: df.name,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '用途',
            dataIndex: df.purpose,
            key: df.purpose,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '使用条件',
            dataIndex: df.condition,
            key: df.condition,
            width: 500,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作人',
            dataIndex: df.operator,
            key: df.operator,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '生成时间',
            dataIndex: df.createTime,
            key: df.createTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            width: cellWidth.time,
            render: (text, item) => this._renderActionCell(item[df.id], item)
        }
    ]);

    _renderActionCell = (key, item) => {
        const { tableAction } = this.props;

        return (
            <div className={styles.action}>
                {item.downloadState == ExportStatus.IN_THE_EXPORT && <div className={styles.item}>生成中</div>}
                {item.downloadState != ExportStatus.IN_THE_EXPORT && <div className={styles.item} onClick={() => tableAction(key, ta.link, item)}>下载报表</div>}
                <div className={styles.item} onClick={() => tableAction(key, ta.edit)}>重新生成</div>
            </div>
        );
    }


    render() {
        const { paginationChange, rowSelection } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;

        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={record=>record.id}
                    columns={this._takeColumns()}
                    rowSelection={rowSelection}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    rowSelection: PropTypes.object,
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;